import React, { Component } from "react";
import { Table, Space, Col, Row, Popconfirm } from "antd";
import { Button, Input } from "antd";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as actions from "../../actions";
import BasicLayout from "../../components/layout/index";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { CSVLink } from "react-csv";
import moment from "moment";

class index extends Component {
  state = {
    searchText: "",
    searchColumn: "",
    visible: false,
    record_id: -1,
  };

  componentDidMount() {
    this.props.getClassBlockDates(this.props.match.params.schedule_id);
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
    this.props.getClassBlockDates(this.props.match.params.schedule_id);
  };

  onDelete = async () => {
    await this.props.deleteClassBlockDate(this.state.record_id);
    this.props.getClassBlockDates(this.props.match.params.schedule_id);
  };

  render() {
    const columns = [
      {
        title: "Block Date",
        width: "130px",
        dataIndex: "class_date",
        key: "class_date",
        ...this.getColumnSearchProps("class_date"),
      },
      {
        title: "Block reason",
        ellipsis: true,
        width: "300px",
        dataIndex: "cancel_reason",
        key: "cancel_reason",
        ...this.getColumnSearchProps("cancel_reason"),
      },
      {
        title: "Action",
        key: "action",
        render: (_text, record) => (
          <Space size="middle">
            <Space size="middle">
              <NavLink to={`block-date/${record.schedule_canceled_id}`}>
                Edit
              </NavLink>
              <Popconfirm
                title="Are you sure you want to delete?"
                visible={
                  this.state.record_id === record.schedule_canceled_id &&
                  this.state.visible
                }
                onConfirm={this.onDelete}
                onCancel={() => this.setState({ visible: false })}
              >
                <Button
                  size="small"
                  type="primary"
                  onClick={() => {
                    this.setState({
                      visible: true,
                      record_id: record.schedule_canceled_id,
                    });
                  }}
                  danger
                >
                  Delete
                </Button>
              </Popconfirm>
            </Space>
          </Space>
        ),
      },
    ];
    let results = [];
    if (this.props.block_dates.length > 0) {
      results = this.props.block_dates.map((row, index) => ({
        ...row,
        class_date: moment(row.class_date).format("DD MMM, YYYY"),
        key: row.schedule_canceled_id,
      }));
    }

    return (
      <BasicLayout>
        <Row>
          <Col md={20}>
            <h4>Class Block Dates</h4>
          </Col>
          <Col md={4}>
            {this.props.block_dates && this.props.block_dates.length > 0 && (
              <CSVLink
                data={this.props.block_dates}
                filename={"block_dates.csv"}
              >
                <Button type="primary" size="small">
                  Download CSV
                </Button>
              </CSVLink>
            )}
          </Col>
        </Row>
        <Table columns={columns} dataSource={results} />
      </BasicLayout>
    );
  }
}

export default connect(
  (state) => ({
    isLoggedIn: state.isLoggedIn,
    admin: state.adminInfo,
    block_dates: state.block_dates,
  }),
  (dispatch) => bindActionCreators({ ...actions }, dispatch)
)(withRouter(index));
